export default __webpack_public_path__ + "static/bonneville-logo-a780106e64cbef6507436b52925e578e.svg";